import { useNavigate } from "react-router-dom";
import { fnbStore, storeData } from "../../../utils/constant";
import { summary_notes_fnb } from "../../../utils/constant";
import DropDown from "../../elements/Dropdown";
import MultiselectDropdown from "../../elements/MultiselectDropdown";
import PieChartComponent from "../../elements/PieChart";
import StackedBarChart from "../../elements/StackedBarChart";
import StoreCard from "../../elements/StoreCard";
import styles from "./index.module.css";
import { useState, useEffect } from "react";
import Header from "../../elements/Header";
import { fetchFnbDashboardData } from "../../../store/slices/fnb/dashboard.slice";
import { useDispatch, useSelector } from "react-redux";
import { useSelectedState } from "rsuite/esm/DateInput";
import PulseLoader from "react-spinners/PulseLoader";
import AIBox from "../../elements/AIBox";
import { fetchAISummaryFromDataAsyncThunk, resetSummary } from "../../../store/slices/ai/ai.slice";
import FnbPriceChangeTable from "../../elements/FnbPriceChangeTable";
import { fetchFnbPriceChanges } from "../../../store/slices/fnb/priceChanges.slice";
import * as XLSX from 'xlsx';

const data = [
  {
    name: "Intl Airside",
    cheapest: 1,
    midrange: 3,
    expensive: 3,
  },
  {
    name: "Domestic",
    cheapest: 1,
    midrange: 3,
    expensive: 3,
  },
  {
    name: "Intl Landside",
    cheapest: 1,
    midrange: 3,
    expensive: 0,
  },
];

const pieData = [
  { name: "Intl Airside", value: 7, color: "#8884d8" },
  { name: "Intl Landside", value: 4, color: "#d3d3d3" },
  { name: "Domestic", value: 7, color: "#a3d9c5" },
];

const sortingSteps = ["Price Rank - Asc", "Price Rank - Dsc"];
const terminalSteps = ["Intl Airside", "Intl Landside", "Domestic"];

const preparePieChartData = (data) => {
  let result = [];
  let colors = {
    "INTL AIRSIDE": "#FF7F50", // Coral
    "INTL LANDSIDE": "#36A2EB", // Sky Blue
    "DOMESTIC LANDSIDE": "#4BCF8F", // Emerald
    "DOMESTIC AIRSIDE": "#FFD166", // Sun Yellow
  };
  data.forEach((element) => {
    let temp = {
      name: element.terminal,
      value:
        Number(element.cheapest_count) +
        Number(element.midrange_count) +
        Number(element.expensive_count),
      color: colors[element.terminal],
    };

    result.push(temp);
  });

  return result;
};

const prepareCardData = (data) => {
  let result = [];
  data.forEach((element) => {
    let temp = {
      title: element.store,
      terminal: element.terminal,
      tp: {
        value:
          Number(element.cheapest_count) +
          Number(element.midrange_count) +
          Number(element.expensive_count),
      },
      ep: {
        value: Number(element.expensive_count),
      },
      mp: {
        value: Number(element.midrange_count),
      },
      cp: {
        value: Number(element.cheapest_count),
      },
    };
    result.push(temp);
  });

  return result;
};

const FnbDashboard = (props) => {
  const [selectedTerminal, setSelectedTerminal] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(2);
  const [selectedYear, setSelectedYear] = useState(2026);
  const [selectedStore, setSelectedStore] = useState([]);
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState('February 2026');
  const {
    dashboardData: { stats, store_stats, terminal_stats, period },
    loading,
  } = useSelector((store) => store.fnbDashboard);
  const {
    data: { store: allStore, terminal: allTerminal },
    loading: constantLoading,
  } = useSelector((store) => store.fnbConstants);
  const {
    priceChangesData: { data: priceChangesData, pagination },
    loading: priceChangesLoading,
  } = useSelector((store) => store.fnbPriceChanges);
  const [store, setStore] = useState();
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getDashboardData = (
    store = selectedStore.length > 0 ? selectedStore.join("|").toUpperCase() : allStore.join("|"),
    terminal = allTerminal.join("|").toUpperCase(),
    search,
    sort = "price_low_to_high",
    month = selectedMonth,
    year = selectedYear
  ) => {
    dispatch(fetchFnbDashboardData({ store, terminal, search, sort, month, year })).then((response) => {
      if (response?.payload?.status === "success" && response?.payload?.ai) {
        dispatch(fetchAISummaryFromDataAsyncThunk({ data: response.payload.ai, notes: summary_notes_fnb }));
      }
    });
  };

  useEffect(() => {
    // Initialize selectedStore with all stores when available
    if (allStore.length > 0 && selectedStore.length === 0) {
      setSelectedStore([...allStore]);
    }
  }, [allStore.length]);

  useEffect(() => {
    if (allStore.length === 0 || allTerminal.length === 0) return;
    if (selectedStore.length === 0 && allStore.length > 0) return; // Wait for initialization
    
    const stores = selectedStore.length > 0 ? selectedStore.join("|").toUpperCase() : allStore.join("|");
    const terminals = allTerminal.join("|").toUpperCase();
    getDashboardData(stores, terminals, search, "price_low_to_high", selectedMonth, selectedYear);
  }, [allStore, allTerminal, selectedStore, selectedMonth, selectedYear, search]);

  // State for pagination and sorting
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("difference_percentage_low_to_high"); // date_desc, diff_high_to_low, diff_low_to_high
  const [isExporting, setIsExporting] = useState(false);
  
  const itemsPerPage = 15;

  
  // Fetch price changes data (skip for May 2025 - no historical data)
  useEffect(() => {
    if (isExporting) return;
    
    if (selectedMonth === 5 && selectedYear === 2025) return;

    const offset = (currentPage - 1) * itemsPerPage;
    dispatch(fetchFnbPriceChanges({ 
      limit: itemsPerPage, 
      offset, 
      sort: sortOrder,
      month: selectedMonth,
      year: selectedYear
    }));
  }, [dispatch, currentPage, sortOrder, selectedMonth, selectedYear, isExporting]);

  // Trigger AI analysis when component mounts or when switching from DF Dashboard
  useEffect(() => {
    if (Object.keys(stats).length > 0 && stats.ai) {
      dispatch(fetchAISummaryFromDataAsyncThunk({ data: stats.ai, notes: summary_notes_fnb }));
    }
  }, [stats, dispatch]);

  useEffect(() => {
    if (store_stats.length > 0) {
      setStore((value) => {
        let newValue = [...prepareCardData(store_stats)];
        let terminals = selectedTerminal?.map((el) => el?.toLowerCase());
        newValue = newValue.filter((val) =>
          terminals?.includes(val?.terminal?.toLowerCase())
        );
        newValue = newValue.filter((val) =>
          val?.title?.toLowerCase()?.includes(search?.toLowerCase())
        );
        return newValue;
      });
    }
  }, [selectedTerminal, search, store_stats]);

  useEffect(() => {
    return () => {
      dispatch(resetSummary());
    };
  }, [dispatch]);

  const onSelectedTerminalsChange = (value) => {
    setSelectedTerminal(value);
  };

  const onSelectedStoreChange = (value) => {
    setSelectedStore(value);
  };

  const handleSearch = (e) => setSearch(e?.target?.value);

  const handleMonthYearChange = (month, year, label) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    setSelectedPeriodLabel(label);
    setCurrentPage(1);
    getDashboardData(
      selectedStore.length > 0 ? selectedStore.join("|").toUpperCase() : allStore.join("|"),
      allTerminal.join("|").toUpperCase(),
      search,
      "price_low_to_high",
      month,
      year
    );
  };

  const redirectToProducts = (e) => {
    let label = e?.currentTarget?.dataset?.label;

    navigate(`/dashboard/fnb-products?label=${label}`);
  };

  // Export to Excel function
  const exportToExcel = async () => {
    if (selectedMonth === 5 && selectedYear === 2025) {
      alert('No historical data available for May 2025');
      return;
    }
    
    try {
      setIsExporting(true);
      const response = await dispatch(fetchFnbPriceChanges({ 
        limit: 10000, 
        offset: 0, 
        sort: sortOrder,
        month: selectedMonth,
        year: selectedYear
      }));
      
      if (response?.payload?.data) {
        const allData = response.payload.data;
        
        // Prepare data for Excel
        const excelData = allData.map((item, index) => {
          const oldPrice = parseFloat(item.old_price);
          const newPrice = parseFloat(item.new_price);
          const percentageChange = ((newPrice - oldPrice) / oldPrice) * 100;
          
          return {
            'S.No': index + 1,
            'Product Name': item.product_name,
            'Store Name': item.store_name,
            'Terminal Name': item.terminal_name,
            'Old Price': `$${oldPrice.toFixed(2)}`,
            'New Price': `$${newPrice.toFixed(2)}`,
            'Difference %': `${percentageChange >= 0 ? '+' : ''}${percentageChange.toFixed(1)}%`
          };
        });

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        ws['!cols'] = [
          { wch: 6 },  // S.No
          { wch: 30 }, // Product Name
          { wch: 25 }, // Store Name
          { wch: 20 }, // Terminal Name
          { wch: 12 }, // Old Price
          { wch: 12 }, // New Price
          { wch: 14 }  // Difference %
        ];

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Price Changes');

        // Generate file name with current date
        const fileName = `FNB_Price_Changes_${new Date().toISOString().split('T')[0]}.xlsx`;

        // Save file
        XLSX.writeFile(wb, fileName);
      }
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };
  return (
    <div className={styles["container"]}>
      <Header 
        onMonthYearChange={handleMonthYearChange}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        storeDropdown={{
          stores: allStore,
          selectedStores: selectedStore,
          onChange: onSelectedStoreChange,
          show: true
        }}
      />
      <hr />
      <div className={styles["ai_box"]}>
        <AIBox isExpand={false} notes={summary_notes_fnb} areTables={true} />
      </div>

      <div className={styles["stats"]}>
        <div
          className={styles["box"]}
          onClick={redirectToProducts}
          data-label=""
        >
          <div className={styles["label"]}>Stores</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading ? <PulseLoader size={10} /> : stats.stores}
            </div>
            {/* <div className={styles["change"]+" "+styles["up"]}>
                        <div>1</div>
                        <div><i class="bi bi-arrow-up-right"></i></div>
                    </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={redirectToProducts}
          data-label=""
        >
          <div className={styles["label"]}>Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading ? <PulseLoader size={10} /> : stats.productCount}
            </div>
            {/* <div className={styles["change"]+" "+styles["down"]}>
                        <div>3</div>
                        <div><i class="bi bi-arrow-down-right"></i></div>
                    </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={redirectToProducts}
          data-label="cheapest"
        >
          <div className={styles["label"]}>Cheapest Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading ? <PulseLoader size={10} /> : stats.cheapestProducts}
            </div>
            {/* <div className={styles["change"]+" "+styles["down"]}>
                        <div>1</div>
                        <div><i class="bi bi-arrow-down-right"></i></div>
                    </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={redirectToProducts}
          data-label="midrange"
        >
          <div className={styles["label"]}>Midrange Products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading ? <PulseLoader size={10} /> : stats.midrangeProducts}
            </div>
            {/* <div className={styles["change"]+" "+styles["down"]}>
                        <div>1</div>
                        <div><i class="bi bi-arrow-down-right"></i></div>
                    </div> */}
          </div>
        </div>
        <div
          className={styles["box"]}
          onClick={redirectToProducts}
          data-label="expensive"
        >
          <div className={styles["label"]}>Expensive products</div>
          <div className={styles["value_box"]}>
            <div className={styles["value"]}>
              {loading ? <PulseLoader size={10} /> : stats.expensiveProducts}
            </div>
            {/* <div className={styles["change"]+" "+styles["down"]}>
                        <div>1</div>
                        <div><i class="bi bi-arrow-down-right"></i></div>
                    </div> */}
          </div>
        </div>
      </div>
      <hr />

      <div className={styles["row"]}>
        <div className={styles["tcompare"]}>
          <div className={styles["tcompare_top"]}>
            <div className={styles["tcompare_head"]}>
              <div>Compare prices per terminal</div>
            </div>
            <div className={styles["tcompare_sub"]}>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#A4D8C9" }}></span>
                </div>
                <div>cheapest</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ffffb7" }}></span>
                </div>
                <div>midrange</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ff9999" }}></span>
                </div>
                <div>expensive</div>
              </div>
            </div>
          </div>
          <div className={styles["tcompare_bottom"]}>
            <StackedBarChart
              url={"/dashboard/fnb-products"}
              data={terminal_stats}
              blueLabel={"cheapest_count"}
              greyLabel={"midrange_count"}
              greenLabel={"expensive_count"}
              type={"terminal"}
            />
          </div>
        </div>
        <div className={styles["distribution"]}>
          <div className={styles["dist_card"]}>
            <div className={styles["dist_head"]}>Product Distribution</div>
            <div className={styles["dist_pie"]}>
              <div>
                <PieChartComponent
                  data={preparePieChartData(terminal_stats)}
                  url={"/dashboard/fnb-products"}
                  customParam="terminal"
                />
              </div>
            </div>
            {/* <div className={styles["dist_label"]}>
              <div className={styles["dist_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ff9999" }}></span>
                </div>
                <div>Intl Airside</div>
              </div>
              <div className={styles["dist_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ffffb7" }}></span>
                </div>
                <div>Intl Landside</div>
              </div>
              <div className={styles["dist_section"]}>
                <div>
                  <span style={{ backgroundColor: "#A4D8C9" }}></span>
                </div>
                <div>Domestic</div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className={styles["row"] + " " + styles["second"]}>
        <div className={styles["tcompare"]}>
          <div className={styles["tcompare_top"]}>
            <div className={styles["tcompare_head"]}>
              <div>Compare prices per store</div>
            </div>
            <div className={styles["tcompare_sub"]}>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#A4D8C9" }}></span>
                </div>
                <div>cheapest</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ffffb7" }}></span>
                </div>
                <div>midrange</div>
              </div>
              <div className={styles["tcompare_section"]}>
                <div>
                  <span style={{ backgroundColor: "#ff9999" }}></span>
                </div>
                <div>expensive</div>
              </div>
            </div>
          </div>
          <div className={styles["tcompare_bottom"]}>
            <StackedBarChart
              url={"/dashboard/fnb-products"}
              data={store_stats}
              blueLabel={"cheapest_count"}
              greyLabel={"midrange_count"}
              greenLabel={"expensive_count"}
              type={"store"}
            />
          </div>
        </div>
      </div>

      {!(selectedMonth === 5 && selectedYear === 2025) && (
        <div className={styles["price_changes_section"]}>
          <div className={styles["price_changes_header"]}>
            <h2>Price Changes</h2>
            <div className={styles["price_changes_controls"]}>
              <div className={styles["dropdown"]}>
                <DropDown
                  steps={["Difference % (High to Low)", "Difference % (Low to High)"]}
                  selectedValue={sortOrder === "difference_percentage_high_to_low" ? 0 : 1}
                  onChange={(value, index) => {
                    const sortValues = ["difference_percentage_high_to_low", "difference_percentage_low_to_high"];
                    setSortOrder(sortValues[index]);
                  }}
                />
              </div>
              <button 
                className={styles["export_button"]}
                onClick={exportToExcel}
                disabled={priceChangesLoading || !priceChangesData || priceChangesData.length === 0}
              >
                <i className="bi bi-download"></i>
                Export to Excel
              </button>
            </div>
          </div>
          <FnbPriceChangeTable 
            data={priceChangesData} 
            loading={priceChangesLoading}
          />
          
          {/* Pagination Controls */}
          {pagination && pagination.total > itemsPerPage && (
            <div className={styles["pagination"]}>
              <div className={styles["pagination_info"]}>
                Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, pagination.total)} of {pagination.total} results
              </div>
              <div className={styles["pagination_controls"]}>
                <button 
                  className={styles["pagination_button"]}
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Previous
                </button>
                
                {/* Page Numbers */}
                {Array.from({ length: Math.min(5, pagination.pages) }, (_, i) => {
                  let pageNum;
                  if (pagination.pages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= pagination.pages - 2) {
                    pageNum = pagination.pages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      className={`${styles["pagination_button"]} ${styles["pagination_number"]} ${
                        currentPage === pageNum ? styles["active"] : ""
                      }`}
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  );
                })}
                
                <button 
                  className={styles["pagination_button"]}
                  disabled={currentPage === pagination.pages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      
      <div className={styles["store"]}>
        <div className={styles["store_head"]}>
          <div className={styles["store_title"]}>Store Statistics</div>
          <div className={styles["store_filters"]}>
            <div className={styles["dropdown"]}>
              <MultiselectDropdown
                steps={allTerminal}
                name="terminals"
                onChange={onSelectedTerminalsChange}
              />
            </div>
            <div className={styles["search"]}>
              <div>
                <input
                  type="text"
                  placeholder="Store"
                  onChange={handleSearch}
                />
                <i class="bi bi-search"></i>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          <div className={styles["store_content"]}>
            {store?.map((el, index) => (
              <StoreCard key={`${el.title}-${el.terminal}-${index}`} {...el} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FnbDashboard;
